import React, { useEffect, useState } from "react";
import useHttp from "../../../../hooks/use-http";
import Pagination from "../../../../components/Pagination";

const ApkHistory = (props) => {
  const { app, onBack } = props;
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(false);
  const [itemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);

  const { sendRequest: getHistory } = useHttp();

  useEffect(() => {
    if (app?.appId) fetchHistory();
  }, [app]);

  const fetchHistory = () => {
    setLoading(true);
    getHistory(
      {
        url: `/api/apkHistory/?appId=${app.appId}`,
      },
      (res) => {
        if (res) {
          const list = Array.isArray(res)
            ? res
            : res.data || res.results || res.history || [];
          setHistory(Array.isArray(list) ? list : []);
        }
        setLoading(false);
      }
    );
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = history.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <>
      <div className="content-wrapper">
        <div className="row mx-2">
          <div className="col-9">
            <label className="card-title mx-3 my-3">
              {app?.appName} — Version History
            </label>
          </div>
          <div className="col-3 text-right">
            <button type="button" className="btn btn-secondary mx-3 my-3" onClick={onBack}>
              <i className="fas fa-arrow-left"></i> Back
            </button>
          </div>
        </div>

        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body" style={{ padding: "0.4rem" }}>
                    {loading ? (
                      <p className="text-muted text-center">Loading history...</p>
                    ) : history.length === 0 ? (
                      <p className="text-muted text-center">
                        No archived versions found for this app.
                      </p>
                    ) : (
                      <table className="table table-bordered text-center">
                        <thead>
                          <tr>
                            <th>Version</th>
                            <th>File Name</th>
                            <th>Size</th>
                            <th>Release Notes</th>
                            <th>Uploaded By</th>
                            <th>Archived At</th>
                          </tr>
                        </thead>
                        <tbody>
                          {currentItems.map((apk, i) => (
                            <tr key={i}>
                              <td>
                                v{apk.version_name}
                                <br />
                                <small className="text-muted">code: {apk.version_code}</small>
                              </td>
                              <td>{apk.file_name}</td>
                              <td>{(apk.file_size / 1024 / 1024).toFixed(2)} MB</td>
                              <td>{apk.release_notes || "—"}</td>
                              <td>{apk.uploaded_by}</td>
                              <td>{apk.archived_at || "—"}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    )}
                  </div>
                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={history.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default ApkHistory;